import React from 'react'

import LoginBg from '../../assets/images/LoginBg.jpg';
import Deliverypage1 from '../../assets/images/deliverypage1.jpg';
import { Link } from 'react-router-dom';

const Delivery = () => {

  return (
    <>
    <style>
      {`
        .AboutusPageSection p{
          margin: 0;
          margin-top: 10px;
          font-weight: 900;
          color: #565656;
          font-size: 30px;
          line-height: 38px;
        }
          `
      }
    </style>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead' style={{ textTransform: 'uppercase' }}>Delivery and Shipping Policy</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 col-sm-7 col-xs-12'>
              <h2>Delivery & Shipping Policy</h2>
              <p>In accordance with the current excise regulations, they must adhere to the established guidelines for delivery and shipping.</p>
            </div>

            <div className='col-md-5 col-sm-5 col-xs-12'>
              <div className='Aboutuspageimg'>
                <img src={Deliverypage1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Delivery